import script from "./DemoDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemoDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DemoDialog.vue?vue&type=style&index=0&id=6470b77a&lang=scss"

const __exports__ = script;

export default __exports__